export const MyBetsTrackingLocation = 'My Bets';
